module.exports = __webpack_public_path__ + "static/img/home-top4.8de4a27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-top4.png
// module id = 3X/6
// module chunks = 21